export default __webpack_public_path__ + "static/media/product-7.52bd86cb.webp";